export default "__VITE_ASSET__2b29cc07__"